import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import ReportedNonconformance from '../../../page/memoMessageTerminateProject/reportedNonconformance/reportedNonconformance'
import { OfficerType } from './officerType'
import * as Constants from '../../../../../../constants/constants'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import ReportedAnonconformance from '../../../page/requestNewProject/reportedAnonconformance/reportedAnonconformance'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import SignREC1 from '../../../page/sign/signMemoMessage/signREC1'
const OfficerView: React.FC<OfficerType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        switch (tabID) {
            case Constants.menuTab.tab1.id: //หน้าตรวจสอบ
            case Constants.menuTab.tab21.id: //หน้ายื่นโครงการ
                return (
                    <ReportedAnonconformance
                        projectData={manageProjectStore?.projectData ?? undefined}
                        onSaveComplete={callbackSaveComplete}
                    />
                )
            case Constants.menuTab.tab11.id:
                return (
                    <ReportedNonconformance
                        projectData={manageProjectStore?.projectData ?? undefined}
                        onSaveComplete={callbackSaveComplete}
                    />
                )
            case Constants.menuTab.tab10.id:
                return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
            case Constants.menuTab.tab9.id:
                return <SignREC1 callbackSaveComplete={callbackSaveComplete} />
            default:
                return <></>
        }
    }
    return <> {renderPage()} </>
}
const Officer: React.FC<OfficerType> = (props) => {
    return <OfficerView {...props} />
}
export default Officer
